module.exports = __webpack_public_path__ + "static/media/Icono bolsas.dff1a4dd.svg";